module.exports = __webpack_public_path__ + "static/media/img1-4.b233d7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/biosense/diff/img1-4.png
// module id = 2376
// module chunks = 3